import { requestHttp } from '@/utils';

const SERVER = ``;

/**
 * 查询REAS系统关注事件信息
 *
 * @typedef { object } EventTrackingAvailableInfo
 * @property { number } dtslTypeId
 * @property { number } dtslVersion
 * @property { string } dtslTypeName
 * @property { number } eventNameId - 事件ID
 * @property { string } eventName - 事件名称
 * @property { string } functionGroup
 * @property { number } eventOrder
 * @property { string } emuType
 * @property { boolean } isDevFun
 */

/**
 * 查询REAS系统关注事件信息列表
 *
 * **接口文档**
 * @see https://lysora.feishu.cn/wiki/wikcnR29pjd1cHAzDbI2vYOk1wd
 *
 * @returns { Promise<EventTrackingAvailableInfo[]> } 返回自定义上报埋点事件列表
 */
export const requestEventTrackingAvailableList = async () => {
  const result = await requestHttp({
    api: `${SERVER}/salon/reas/getAllEvent`,
    method: 'GET',
    module: 'enet'
  });

  if (result.code === 0) {
    return result.data;
  } else {
    return Promise.reject(result);
  }
};

/**
 * 上报自定义事件埋点数据
 *
 * **接口文档**
 * @see https://lysora.feishu.cn/wiki/wikcnR29pjd1cHAzDbI2vYOk1wd#AcMEds26YoyIcwxeqf3cfNP9nCh
 *
 * @param { object } params - 上报参数
 * @param { string } params.staId - 唯一标识
 * @param { string } params.eMd5 - MD5 加密
 * @param { number } params.eOrder - 当日发送次数，从 1 开始
 * @param { object[] } params.eList - 事件列表
 * @param { string | number } params.eList[].userId - 用户 ID
 * @param { string } params.eList[].eName - 事件名称
 * @param { string | number } params.eList[].ts - 时间戳
 * @param { string | number } params.eList[].tz - 时区偏移量
 * @param { string } [params.eList[].mainSn] - 网络主设备SN
 * @returns { Promise } 返回 Promise
 */
export const requestEventTracking = async params => {
  const result = await requestHttp({
    api: `${SERVER}/salon/reas/uploadUserEvent`,
    method: 'POST',
    module: 'enet',
    params
  });

  if (result.code === 0) {
    return result.data;
  } else {
    return Promise.reject(result);
  }
};
